
import { inject } from '@angular/core';
import { HttpEvent, HttpRequest, HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { NGXLogger } from 'ngx-logger';
import { TimedDialogService } from './timedDialog.service';
import { ConfigService } from './config/config.service';

const arpSessionTimeoutMessage = "HTTP 401: Unauthorized";

export const httpInterceptorFn: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const config = inject(ConfigService);
  const router = inject(Router);
  const logger = inject(NGXLogger);
  const timedDialogService = inject(TimedDialogService);

  const token = sessionStorage.getItem('access_token');
  if (req.url.includes('office-api') || req.url.includes('tpa-api')) {
    if (!config.arpUsap) {
      timedDialogService.showDialogAfterDelay();
    }
  }
  const changedReq = req.clone({
    setHeaders: {
      Authorization: 'Bearer ' + token,
    },
  });
  return next(changedReq).pipe(tap({
    // do nothing here on success
    error: (err) => {
      if (err instanceof HttpErrorResponse && err.status === 401) {
        if (err.error) {
          let errorObj = err.error;
          // Parsing is failing due some of cases value is returned as string
          if (typeof errorObj === 'string') {
            errorObj = JSON.parse(errorObj);
          }
          if (errorObj.errors && errorObj.errors[0] && errorObj.errors[0].code === 37355) {
            // Permission denied
            logger.error('Unauthorized: '
              + errorObj.errors[0].code + '-' +
              errorObj.errors[0].message);
            return;
          }
        }
        // TODO remove alert add custom dialog
        logger.error('Server response: 401. Redirecting to Login page');
        alert('Session Timeout. Please Login');
        sessionStorage.clear();
        // naviagation is not working already other navigation is in progress
        if (config.arpUsap) {
          window.parent.postMessage(arpSessionTimeoutMessage, "*");
        } else {
          router.navigate(['/login']);
        }
        // return throwError(new NavigationCancel(4, '', ''));
      }
    }
  }));
};
